import { styled } from '@mui/material/styles';
import { Box, Grid } from '@mui/material';
import CallManagement from './CallManagement';
import KPIs from './KPIs';
import TasksTable from './TasksTable';
import Performance from './Performance';
import OverrideApprovals from './OverrideApprovals';

const PREFIX = 'LandingPage';

const classes = {
  container: `${PREFIX}-container`,
  mainContent: `${PREFIX}-mainContent`,
  rightSidebar: `${PREFIX}-rightSidebar`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  [`& .${classes.mainContent}`]: {
    order: 1,
    flexGrow: 1,
    [theme.breakpoints.up('lg')]: {
      paddingRight: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
  [`& .${classes.rightSidebar}`]: {
    order: 2,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(2),
    },
  },
}));

export default function LandingPage() {
  return (
    <StyledGrid container className={classes.container} spacing={3}>
      <Grid item className={classes.mainContent}>
        {/* <Box mb={2}>
          <KPIs />
        </Box> */}
        <Box mb={2}>
          <OverrideApprovals />
        </Box>
        {/* <Box mb={2}>
          <CallManagement />
        </Box> */}

        {/* <TasksTable /> */}
      </Grid>
      {/* <Grid item xs={12} lg={4} className={classes.rightSidebar}>
        <Performance />
      </Grid> */}
    </StyledGrid>
  );
}
